var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { staticClass: "info-item" }, [
        _c("p", { staticClass: "info-title" }, [
          _vm._v(_vm._s(_vm.$t("panel.create_by"))),
        ]),
        _c("p", { staticClass: "info-content" }, [
          _vm._v(_vm._s(_vm.panelInfo.creatorName)),
        ]),
      ]),
      _c("el-col", { staticClass: "info-item" }, [
        _c("p", { staticClass: "info-title" }, [
          _vm._v(_vm._s(_vm.$t("panel.create_time"))),
        ]),
        _c("p", { staticClass: "info-content" }, [
          _vm._v(
            _vm._s(_vm._f("timestampFormatDate")(_vm.panelInfo.createTime))
          ),
        ]),
      ]),
      _c("el-col", { staticClass: "info-item" }, [
        _c("p", { staticClass: "info-title" }, [
          _vm._v(_vm._s(_vm.$t("panel.update_by"))),
        ]),
        _c("p", { staticClass: "info-content" }, [
          _vm._v(_vm._s(_vm.panelInfo.updateName || "N/A")),
        ]),
      ]),
      _c("el-col", { staticClass: "info-item" }, [
        _c("p", { staticClass: "info-title" }, [
          _vm._v(_vm._s(_vm.$t("panel.update_time"))),
        ]),
        _vm.panelInfo.updateTime
          ? _c("p", { staticClass: "info-content" }, [
              _vm._v(
                _vm._s(_vm._f("timestampFormatDate")(_vm.panelInfo.updateTime))
              ),
            ])
          : _vm._e(),
        !_vm.panelInfo.updateTime
          ? _c("p", { staticClass: "info-content" }, [_vm._v("N/A")])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }